import { CpdDto } from '../models/cpdDto';
import { formatDate, getLocalDate } from '../../../app/utils/util';

export const cpdDefaultValues = {
    ActivityDate: '', Category: '', ActivityType: '', Domains: '',
    CreditsClaiming: '', Description: '', DevelopmentPurpose: '',
    AccreditedCeActivity: '', PracticeReview: '', WorkbasedLearning: ''
};

export function getCpdActivityYear(value: unknown): number | null {
    if (!(value instanceof Date) && typeof value !== 'string') return null;
    if (value === '') return null;
    const date = new Date(value.toString());
    // Partial years can be valid Date objects, so also check the allowed range.
    if (Number.isNaN(date.getTime()) || date < new Date(2025, 4, 1) || date > new Date()) return null;
    const year = date.getUTCFullYear();
    return date <= new Date(year, 3, 30, 23, 59, 59, 999) ? year - 1 : year;
}

export function mapCpdToFormValues(details: CpdDto, clearDate: boolean) {
    return {
        ActivityDate: clearDate ? '' : getLocalDate(details.activityDate),
        Category: details.cpdCategoryId,
        ActivityType: details.activityTypeId,
        Domains: details.goodPracticeDomainIds,
        CreditsClaiming: details.credits,
        Description: details.description ?? '',
        DevelopmentPurpose: details.purpose ?? ''
    };
}

export function mapCpdFormToDto(values: Record<string, unknown>, personId: string, creditRecordId?: string): CpdDto {
    return {
        ...(creditRecordId ? { creditRecordId } : {}),
        activityDate: formatDate(new Date(String(values.ActivityDate))),
        cpdCategoryId: String(values.Category),
        activityTypeId: String(values.ActivityType),
        goodPracticeDomainIds: Array.isArray(values.Domains) ? values.Domains.filter((id): id is string => typeof id === 'string') : [],
        credits: Number(values.CreditsClaiming),
        description: String(values.Description ?? ''),
        purpose: String(values.DevelopmentPurpose ?? ''),
        personId
    };
}
